import { Badge } from '@/components/ui/badge';
import type {
  CompanionCoverageSummary,
  CompanionMemberCoverages,
} from '@/services/types/coverage-types';

import { CoverageStatusBadge } from '../CoverageStatusBadge';
import { categoryBadgeConfig } from '../shared/constants';

interface CompanionCoverageRowProps {
  coverage: CompanionCoverageSummary;
}

const CompanionCoverageRow = ({
  coverage,
}: CompanionCoverageRowProps) => {
  return (
    <div className="flex items-center justify-between gap-2 p-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
            {coverage.carrier_name || 'Unknown Carrier'}
          </p>
          <Badge
            variant="outline"
            className="text-xs font-medium px-1.5 py-0 shrink-0"
          >
            {(coverage.category && categoryBadgeConfig[coverage.category]?.text) || 'Other'}
          </Badge>
        </div>
        {coverage.policy_number && (
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mt-0.5 truncate">
            {coverage.policy_number}
          </p>
        )}
      </div>
      <div className="shrink-0">
        <CoverageStatusBadge status={coverage.status} />
      </div>
    </div>
  );
};

interface CompanionMatterSectionProps {
  member: CompanionMemberCoverages;
}

export const CompanionMatterSection = ({
  member,
}: CompanionMatterSectionProps) => {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-md bg-gray-50 dark:bg-gray-800">
      <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-700">
        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
          {member.matter_name}
        </p>
      </div>
      <div className="p-2 space-y-1.5">
        {member.coverages.length > 0 ? (
          member.coverages.map((coverage) => (
            <CompanionCoverageRow
              key={coverage.id}
              coverage={coverage}
            />
          ))
        ) : (
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 px-1 py-2">
            No coverages found
          </p>
        )}
      </div>
    </div>
  );
};
